import Tab from "./Tab";
import axios from 'axios'

const tab = new Tab()

export default class Drawer {
  constructor() {
    this._drawerInit = document.querySelectorAll(".jsDrawerInit");
    this._drawer = document.querySelectorAll(".jsDrawer");
    this._drawerClose = document.querySelectorAll(".jsDrawerClose");
    this._ajaxContent =   document.getElementById("ajax-drawer-content")
    this._loadedContent = document.getElementById("ajax-drawer-content")
    this._wrapper = '';

    if (this._drawerInit) this.init();
  }

  // Open specfied drawer
  openDrawer(i)
  {

    // Check if an Australian or British user
    if ( typeof countryCode !== 'undefined' && (countryCode == "AU" || countryCode == "GB" || countryCode == "IM") )
    {
      switch (countryCode)
      {

        case "GB":
        case "IM":
          // Simulate an HTTP redirect:
          window.location.replace("https://www.ijmuk.org/give/freedom");
          break;

        case "AU":
          // Simulate an HTTP redirect:
          window.location.replace("https://ijm.org.au/give/?camId=7010K000001byse&utm_source=ijm-us-website&utm_medium=redirect&utm_campaign=ijm-us");
          break;
      }
    }
    else
    {

      // Show mask if desktop+
      if (window.innerWidth > 1023) this.renderMask(i);

      // Mark drawer as active & add class to body
      i.classList.add('is-active')
      document.body.classList.add('state-drawer-open')

      // Add special class to body if this is the Give drawer
      if (parseInt(i.dataset.id, 10) === 0) {
        document.body.classList.add('state-drawer-give-open')
      }

      // Get the wrapper (this is actually inside the drawer)
      this._wrapper = i.querySelector(".drawer__wrap");

      // Is the wrapper in "Show loading spinner" mode, and does it have a URL to fetch?
      if(this._wrapper.classList.contains("loading") && typeof(this._wrapper.dataset.url) !== "undefined")
      {
        // Make this drawer's wrapper the target for the AJAX'ed content
        this._ajaxContent = this._wrapper;
        this.ajax(this._wrapper.dataset.url, true);
      }
    }
  }

  closeDrawer(i) {
    if (window.innerWidth > 1023) this.hideMask(i);
    i.classList.remove('is-active')
    history.pushState("#", document.title, window.location.pathname);
    document.body.classList.remove('state-drawer-open')
    document.body.classList.remove('state-drawer-give-open')
  }

  renderMask(i) {
    if(i.nextSibling.classList != undefined && i.nextSibling.classList.contains("jsDrawerMask")) {
      i.nextSibling.classList.add("active");
    } else {
      i.nextSibling.nextSibling.classList.add("active");
    }
  }

  hideMask(i) {
    if(i.nextSibling.classList != undefined && i.nextSibling.classList.contains("jsDrawerMask")) {
      i.nextSibling.classList.remove("active");
    } else {
      i.nextSibling.nextSibling.classList.remove("active");
    }
  }

  switchTab () {
    tab.getContent(tab._tab[1], 1);
    tab.switchHeader(1)
  }

  searchDrawer(type, i) {
    let z = this._drawer.length;
    for (let y = 0; y < z; y++) {
      if (this._drawer[y].dataset.id === i.dataset.id) {
        switch (type) {
          case "OPEN":
            this.openDrawer(this._drawer[y]);
            break;
          case "CLOSE":
            this.closeDrawer(this._drawer[y]);
            break;
        }
      }
    }
  }

  ajax (url, withLoader = false)
  {
    axios.get(url).then((response) =>
    {
      this._ajaxContent.innerHTML = `<div class="ajaxed-content">${response.data}</div>`;

      // Append any extra scripts to the body
      if(typeof(this._wrapper.dataset.scripts) !== "undefined")
      {
        var scripts = JSON.parse(this._wrapper.dataset.scripts);
        scripts.forEach(function (script, index) {
          var js = document.createElement("script");
          js.type = "text/javascript";
          js.async = "";
          js.src = script;
          document.body.appendChild(js);
        });
      }

      this._wrapper.classList.remove('loading');
      this._wrapper.focus();
      // Attach to new close button
      this.addCloseTrigger( this._wrapper.querySelector(".jsDrawerClose") )
    })
  }

  // Listens for clicks on the specified (close button) element
  addCloseTrigger (btn) {
    btn.addEventListener("click", (event) => {
      event.preventDefault()
      this.searchDrawer("CLOSE", btn);
    });
  }

  addContent (contentId) {
    this._loadedContent.innerHTML = document.getElementById(contentId).innerHTML;
  }

  init() {
    let l = this._drawerInit.length;
    for (let i = 0; i < l; i++) {
      this._drawerInit[i].addEventListener("click", (event) => {
        event.preventDefault()
        this.searchDrawer("OPEN", this._drawerInit[i]);

        if (this._drawerInit[i].dataset.type === 'ajax') {
          this._ajaxContent.innerHTML = '<div></div>';
          this.ajax(this._drawerInit[i].href)
        } else if (this._drawerInit[i].dataset.type === 'content') {
          this._loadedContent.innerHTML = '<div></div>';
          this.addContent(this._drawerInit[i].dataset.contentId);
        }

        if (this._drawerInit[i].classList.contains("jsDonateSwitch")) {
          this.switchTab();
        }
      });
    }

    l = this._drawerClose.length;
    for (let i = 0; i < l; i++) {
      this.addCloseTrigger(this._drawerClose[i])
    }
  }
}
